module.exports = __webpack_public_path__ + "img/浙江工业大学LOGO.38a0ca47.png";